import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useSessionContext } from '@providers/session'
import { i18WithParams as t } from '@shared/locale'
import { useRoutes } from 'app/use_routes'
import { Spacer, Spacer3 } from 'components-ui/src/spacer/spacer'
import { Hooks } from 'service-api'
import { CheckList } from './check_list'
import { checkCompliant, processPreRegValidation } from './helper'

export const SummaryValidation = ({ orderId }: { orderId: string }) => {
  const theme = useTheme()
  const sessionCtx = useSessionContext()
  const { accountName: locationName = '' } = useParams()
  const preRegValidation = Hooks.useAdminPreRegValidationOrder(
    locationName,
    sessionCtx.state.user?.lupId || '',
    orderId
  )
  const { buildPath } = useRoutes()

  const { regData, isPreRegCompliant } = useMemo(() => {
    if (preRegValidation.isSuccess) {
      return {
        regData: processPreRegValidation(preRegValidation.data),
        isPreRegCompliant: checkCompliant(preRegValidation.data),
      }
    }
    return { regData: null, isPreRegCompliant: true }
  }, [preRegValidation.data, preRegValidation.isSuccess])

  if (preRegValidation.isError) {
    return null
  }
  if (preRegValidation.isLoading) {
    return (
      <>
        <Spacer3 />
        <Skeleton variant="rounded" width="100%" height={50} />
      </>
    )
  }

  const pageTitle = isPreRegCompliant ? t('prereg.allSet.title') : t('prereg.title')
  const pageLead = isPreRegCompliant ? t('prereg.allSet.lead') : t('prereg.lead')

  return (
    <>
      <Spacer3 />
      <Paper elevation={1} sx={{ backgroundColor: theme.palette.primary.shade12 }}>
        <Box p={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <CheckBoxIcon fontSize="large" />
            <Typography variant="h5">{pageTitle}</Typography>
          </Stack>

          <Spacer height={2} />
          <Typography variant="body1bold" ml={0.5}>
            {pageLead}
          </Typography>
          <Spacer height={2} />

          {!isPreRegCompliant && <CheckList regData={regData} useLinks={false} useIcons={true} lppId={''} />}

          <Button size="large" component="a" variant="contained" href={buildPath('profile', {})}>
            {t('prereg.myAccount')}
          </Button>
        </Box>
      </Paper>
    </>
  )
}
